import { useRef } from 'react';
// import { LazyLoadImage } from "react-lazy-load-image-component";
import { useTheme } from '@mui/material/styles';
import {
	Grid,
	Card,
	CardContent,
	IconButton,
	useMediaQuery,
	Divider,
	Button,
	Typography,
	Box,
	List,
	Avatar,
	ImageList,
	ImageListItem,
	ListItem,
	ListItemText,
	ListItemAvatar,
	CardActions,
	ToggleButtonGroup,
	ToggleButton,
	Skeleton,
	TextField,
	Checkbox,
	CircularProgress,
	FormHelperText,
	FormHelperTextProps,
	FormGroup,
	FormControlLabel,
	FormControl,
	OutlinedInput,
	InputAdornment,
	LinearProgress,
	MenuItem,
} from '@mui/material';

import { ImageLoader } from '~/content/components/ImageLoader';
import { Link, useLocation } from '@remix-run/react';
import Scroll from 'react-scroll';
// import workflow_hero_dark from '~/content/images/workflows/workflow_hero_dark.webp';
import workflow_hero from '~/content/images/workflows/workflow_hero.webp';
import { useTranslation } from 'react-i18next';
import { useLoaderData } from '@remix-run/react';

const Hero = (): JSX.Element => {
	const workflow_heroRef = useRef(null);
	let { t } = useTranslation(['workflows']);
	const { userLanguage } = useLoaderData();
	const link_prefix = userLanguage === 'en' ? '/en' : '';

	const theme = useTheme();
	const isMd = useMediaQuery(theme.breakpoints.up('md'), {
		defaultMatches: true,
	});

	const LeftSide = () => (
		<Box>
			<Box marginBottom={2}>
				<Typography component={'h1'} variant='h3' sx={{ fontWeight: 700 }}>
					{t('hero_headline')}
				</Typography>
			</Box>
			<Typography marginBottom={3} variant='h6' component={'p'} color='text.secondary'>
				{t('hero_subheadline')}
			</Typography>

			{/* <Box display='flex' flexDirection={{ xs: 'column', sm: 'row' }} alignItems={{ xs: 'stretched', sm: 'flex-start' }}> */}
			<Grid
				container
				spacing={{ xs: 0, sm: 2, md: 2 }}
				direction='row'
				justifyContent='flex-start'
				alignItems='center'
			>
				<Grid item xs={12} sm={6} md={'auto'}>
					<Button
						sx={{
							borderRadius: '0',
							rel: 'nofollow',
						}}
						variant='contained'
						color='primary'
						size='large'
						onClick={(e) => {
							e.preventDefault();
							// let support = document.getElementById('support');
							// support?.scrollIntoView({ behavior: 'smooth' });

							Scroll.scroller.scrollTo('features', {
								duration: 1000,
								// delay: 100,
								smooth: true,
								// containerId: 'ContainerElementID',
								offset: -15, // Scrolls to element + 50 pixels down the page
							});
						}}
						fullWidth={isMd ? false : true}
					>
						{t('hero_button_1')}
					</Button>
				</Grid>
				<Grid item xs={12} sm={6} md={'auto'}>
					<Link
						to={link_prefix + '/contact/?scrollTo=video-call'}
						prefetch='intent'
						style={{
							textDecoration: 'none',
							width: isMd ? 'auto' : '100%',
						}}
						onClick={(e) => {
							e.stopPropagation();
						}}
					>
						<Box
							sx={{
								borderRadius: '0',
							}}
							component={Button}
							variant='outlined'
							color='primary'
							size='large'
							marginTop={{ xs: 2, sm: 0 }}
							// marginLeft={{ sm: 2 }}
							fullWidth={isMd ? false : true}
						>
							{t('hero_button_2')}
						</Box>
					</Link>
				</Grid>
			</Grid>
		</Box>
	);

	return (
		<Grid container spacing={4}>
			<Grid item container alignItems={'center'} xs={12} md={6} order={{ xs: 1, md: 0 }}>
				<Box>
					<LeftSide />
				</Box>
			</Grid>
			<Grid item xs={12} md={6} order={{ xs: 0, md: 1 }}>
				<Box
				// sx={{
				//   display: 'flex',
				//   justifyContent: 'center',
				//   alignItems: 'center',
				// }}
				>
					<ImageLoader
						delay={true}
						intersectViewportCheck={true}
						style={{
							display: 'flex',
							justifyContent: 'center',
							alignItems: 'center',
						}}
						childRef={workflow_heroRef}
					>
						<Box
							ref={workflow_heroRef}
							component={'img'}
							height={1}
							width={1}
							maxWidth={{ xs: 320, md: 530 }}
							src={workflow_hero}
							alt='Professionelle digitale KI-/Geschäftsprozesse Hessen'
							sx={{
								// alignSelf: 'center',
								filter: theme.palette.mode === 'dark' ? 'brightness(0.9)' : 'none',
							}}
						/>
					</ImageLoader>
				</Box>
			</Grid>
		</Grid>
	);
};

export default Hero;
